import { PurchaseItemStatus } from "common";
import { PaymentMethod, Purchase, PurchaseItem } from "types";
import {
    getPurchasePaymentMethod,
    getPurchasePendingPaymentMethod,
    isSplitPayPurchase,
} from "../../../models/Purchase";

export const purchaseTypeActions: any = {
    [PurchaseItemStatus.CONFIRMED]: {
        title: "Accept",
        messageLabel: "Send a Message to the Customer (Optional)",
    },
    [PurchaseItemStatus.DECLINED]: {
        title: "Decline",
        messageLabel: "Explanation to guest about why you are declining this reservation",
    },
};

export const shouldShowDoNotChargeNow = (
    purchase: Purchase,
    item: PurchaseItem,
    updatedStatus: PurchaseItemStatus.CONFIRMED | PurchaseItemStatus.DECLINED,
) => {
    const isSplitPayPayerEnabled = isSplitPayPurchase(purchase);
    const isPendingItem = [PurchaseItemStatus.PENDING_ACCEPT, PurchaseItemStatus.PENDING_MINIMUM].includes(item.status);
    const hasConfirmedCCPayment = getPurchasePaymentMethod(purchase)?.name === PaymentMethod.CREDIT_CARD;
    const hasPendingCCPayment = getPurchasePendingPaymentMethod(purchase) === PaymentMethod.CREDIT_CARD;
    const hasCCPayment = hasPendingCCPayment || (hasConfirmedCCPayment && isPendingItem);

    return !isSplitPayPayerEnabled && updatedStatus === PurchaseItemStatus.CONFIRMED && hasCCPayment;
};
